import { render, staticRenderFns } from "./CreateFolderIcon.vue?vue&type=template&id=29cc73ee"
import script from "./CreateFolderIcon.vue?vue&type=script&lang=js"
export * from "./CreateFolderIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports